module.exports = {
      id: "pre-blue-carcass-usage",
      viewBox: "0 0 46 48",
      url: __webpack_public_path__ + "sprite-d2a4e8aaeb47684d6d07571fc646b0db.svg#pre-blue-carcass",
      toString: function () {
        return this.url;
      }
    }